import queryString from "query-string"
import { api, TAGS } from "store/api"
import { ElixirModel } from "store/apis/elixirsAPI/values"
import {
  IDarkActiveElixir,
  IDarkElixirsInventoryResponse
} from "./dark-elixirs.types"

export const darkElixirsEndpoints = api
  .enhanceEndpoints({
    addTagTypes: [TAGS.DARK_ELIXIRS_INVENTORY, TAGS.DARK_ELIXIRS_ACTIVATED]
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getUsersDarkElixirs: builder.query<
        IDarkElixirsInventoryResponse,
        { page: number; limit: number }
      >({
        query: ({ page, limit }) => {
          const qs = queryString.stringify(
            { page, limit, elixirModels: ElixirModel.DARK },
            { skipNull: false, skipEmptyString: true }
          )
          return { url: `/elixirs/elixirs-instances?${qs}`, method: "GET" }
        },
        providesTags: (result) =>
          result
            ? [
                ...(result.items || []).map(({ _id }) => ({
                  type: TAGS.DARK_ELIXIRS_INVENTORY as const,
                  id: _id
                })),
                { type: TAGS.DARK_ELIXIRS_INVENTORY, id: "LIST" }
              ]
            : [{ type: TAGS.DARK_ELIXIRS_INVENTORY, id: "LIST" }]
      }),

      getActivatedDarkElixirs: builder.query<IDarkActiveElixir[], void>({
        query: () => ({ url: `/dark-elixirs/active`, method: "GET" }),
        providesTags: [{ type: TAGS.DARK_ELIXIRS_ACTIVATED, id: "LIST" }]
      }),

      activateDarkElixir: builder.mutation<void, { id: string }>({
        query: ({ id }) => ({
          url: `/dark-elixirs/activate/${id}`,
          method: "PATCH"
        }),
        invalidatesTags: [
          { type: TAGS.DARK_ELIXIRS_INVENTORY, id: "LIST" },
          { type: TAGS.DARK_ELIXIRS_ACTIVATED, id: "LIST" }
        ]
      })
    })
  })

export const {
  useGetUsersDarkElixirsQuery,
  useGetActivatedDarkElixirsQuery,
  useActivateDarkElixirMutation
} = darkElixirsEndpoints
